import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  empresa: {
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: '10px',
    fontFamily: 'serif',
  },
  tituloProdutos: {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginTop: '10px',
    fontFamily: 'serif',
  },
  texto: {
    fontSize: '1rem',
    fontFamily: 'serif',
  },
  observation: {
    fontSize: '1.1rem',
    fontFamily: 'serif',
    textTransform: 'uppercase',
  },
  productText: {
    fontSize: '1.2rem',
    fontFamily: 'serif',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  clienteInfo: {
    fontSize: '1rem',
    fontFamily: 'serif',
    '& > strong': {
      fontWeight: 700,
      textTransform: 'uppercase'
    }
  },
  nomeComplemento: {
    fontSize: '1.1rem',
    fontWeight: 500,
    fontFamily: 'serif',
    textTransform: 'uppercase'
  },
  precoComplemento: {
    minWidth: 'max-content',
    fontSize: '.9rem',
    fontFamily: 'serif',
  },
  totalItem: {
    minWidth: 'max-content',
    fontSize: '.9rem',
    fontFamily: 'serif',
  },
  divider: {
    width: '100%',
    backgroundColor: 'black',
    margin: '10px 0px 10px 0px',
    fontFamily: 'serif',
  },
}));
